import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import useAuth from 'client/utils/auth/useAuth';
import { HOME_PAGE } from 'client/utils/routes/routeConstants';

const RequiresSignedOut = ({ children = [], redirectWhenSignedIn = HOME_PAGE }) => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate(redirectWhenSignedIn);
        }
    }, [isAuthenticated]);

    return <>{!isAuthenticated && children}</>;
};

export default RequiresSignedOut;
